import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["regionRadio", "productSelect"];

  connect() {
    this.filterProducts();
  }

  filterProducts() {
    const selectedRegion = this.selectedRegion();
    
    if (!selectedRegion) {
      this.showAllProducts();
      return;
    }

    const allowedProducts = this.getAllowedProducts(selectedRegion);
    
    Array.from(this.productSelectTarget.options).forEach(option => {
      if (option.value === "") {
        option.style.display = "";
        return;
      }

      if (allowedProducts.includes(option.value)) {
        option.style.display = "";
      } else {
        option.style.display = "none";
        
        if (option.selected) {
          this.productSelectTarget.value = "";
        }
      }
    });
  }

  selectedRegion() {
    const checkedRadio = this.regionRadioTargets.find(radio => radio.checked);
    return checkedRadio ? checkedRadio.value : null;
  }

  getAllowedProducts(region) {
    const regionProductMap = {
      "US": ["R&W", "ATE", "Tax", "Tax Credit", "IP", "Contingent"],
      "EU": ["W&I", "ATE", "Tax", "Tax Credit", "IP", "Contingent"],
      "APAC": ["W&I", "ATE", "Tax", "Tax Credit", "IP", "Contingent"]
    };

    return regionProductMap[region] || [];
  }

  showAllProducts() {
    Array.from(this.productSelectTarget.options).forEach(option => {
      option.style.display = "";
    });
  }
}

